import {
  ValueTimeMark3e7hmed1q029a as ValueTimeMark,
  _ValueTimeMark___init__impl__uyfl2m2gtayge1xz2lu as _ValueTimeMark___init__impl__uyfl2m,
  _ValueTimeMark___get_reading__impl__5qz8rd2ukehxhkn951e as _ValueTimeMark___get_reading__impl__5qz8rd,
} from './TimeSource.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  contentToString3ujacv8hqfipd as contentToString,
} from '../collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  DurationUnit_NANOSECONDS_getInstance3qw1csxyijo35 as DurationUnit_NANOSECONDS_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
} from './DurationUnitJs.mjs';
import {
  toDuration28gf6ughsr3vf as toDuration,
  Duration__plus_impl_yu9v8f2as9k1ghoc0eo as Duration__plus_impl_yu9v8f,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
} from './Duration.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MonotonicTimeSourceClass;
function MonotonicTimeSource() {
  if (MonotonicTimeSourceClass === VOID) {
    class $ {
      constructor() {
        MonotonicTimeSource_instance = this;
        var tmp = this;
        // Inline function 'kotlin.run' call
        var isNode = typeof process !== 'undefined' && process.versions && !!process.versions.node;
        var tmp_0;
        if (isNode) {
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp$ret$2 = process;
          tmp_0 = new (HrTimeSource())(tmp$ret$2);
        } else {
          // Inline function 'kotlin.js.unsafeCast' call
          var tmp0_safe_receiver = typeof self !== 'undefined' ? self : globalThis;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.performance;
          var tmp_1;
          if (tmp1_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_1 = new (PerformanceTimeSource())(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp_1;
          tmp_0 = tmp2_elvis_lhs == null ? DateNowTimeSource_instance : tmp2_elvis_lhs;
        }
        tmp.xh_1 = tmp_0;
      }
      yh() {
        return this.xh_1.yh();
      }
      zh() {
        return new (ValueTimeMark())(this.yh());
      }
      ai(timeMark) {
        return this.xh_1.ai(timeMark);
      }
      bi(one, another) {
        return this.xh_1.bi(one, another);
      }
    }
    initMetadataForObject($, 'MonotonicTimeSource');
    MonotonicTimeSourceClass = $;
  }
  return MonotonicTimeSourceClass;
}
var MonotonicTimeSource_instance;
function MonotonicTimeSource_getInstance() {
  if (MonotonicTimeSource_instance === VOID)
    new (MonotonicTimeSource())();
  return MonotonicTimeSource_instance;
}
var ReadingClass;
function Reading() {
  if (ReadingClass === VOID) {
    class $ {
      constructor(components) {
        this.ci_1 = components;
      }
      equals(other) {
        var tmp;
        if (other instanceof Reading()) {
          tmp = contentEquals(this.ci_1, other.ci_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return contentHashCode(this.ci_1);
      }
      toString() {
        return contentToString(this.ci_1);
      }
    }
    initMetadataForClass($, 'Reading');
    ReadingClass = $;
  }
  return ReadingClass;
}
var HrTimeSourceClass;
function HrTimeSource() {
  if (HrTimeSourceClass === VOID) {
    class $ {
      constructor(process) {
        this.di_1 = process;
      }
      yh() {
        return _ValueTimeMark___init__impl__uyfl2m(new (Reading())(this.di_1.hrtime()));
      }
      zh() {
        return new (ValueTimeMark())(this.yh());
      }
      ai(timeMark) {
        var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
        // Inline function 'kotlin.let' call
        var destruct = this.di_1.hrtime((tmp instanceof Reading() ? tmp : THROW_CCE()).ci_1);
        // Inline function 'kotlin.collections.component1' call
        var seconds = destruct[0];
        // Inline function 'kotlin.collections.component2' call
        var nanos = destruct[1];
        return Duration__plus_impl_yu9v8f(toDuration(seconds, DurationUnit_SECONDS_getInstance()), toDuration(nanos, DurationUnit_NANOSECONDS_getInstance()));
      }
      bi(one, another) {
        var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
        var _destruct__k2r9zo = tmp instanceof Reading() ? tmp : THROW_CCE();
        // Inline function 'kotlin.time.Reading.component1' call
        // Inline function 'kotlin.collections.component1' call
        var s1 = _destruct__k2r9zo.ci_1[0];
        // Inline function 'kotlin.time.Reading.component2' call
        // Inline function 'kotlin.collections.component2' call
        var n1 = _destruct__k2r9zo.ci_1[1];
        var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
        var _destruct__k2r9zo_0 = tmp_0 instanceof Reading() ? tmp_0 : THROW_CCE();
        // Inline function 'kotlin.time.Reading.component1' call
        // Inline function 'kotlin.collections.component1' call
        var s2 = _destruct__k2r9zo_0.ci_1[0];
        // Inline function 'kotlin.time.Reading.component2' call
        // Inline function 'kotlin.collections.component2' call
        var n2 = _destruct__k2r9zo_0.ci_1[1];
        return Duration__plus_impl_yu9v8f(s1 === s2 && n1 === n2 ? Companion_getInstance().fi_1 : toDuration(s1 - s2, DurationUnit_SECONDS_getInstance()), toDuration(n1 - n2, DurationUnit_NANOSECONDS_getInstance()));
      }
      toString() {
        return 'TimeSource(process.hrtime())';
      }
    }
    initMetadataForClass($, 'HrTimeSource');
    HrTimeSourceClass = $;
  }
  return HrTimeSourceClass;
}
function read($this) {
  return $this.ki_1.now();
}
var PerformanceTimeSourceClass;
function PerformanceTimeSource() {
  if (PerformanceTimeSourceClass === VOID) {
    class $ {
      constructor(performance) {
        this.ki_1 = performance;
      }
      yh() {
        return _ValueTimeMark___init__impl__uyfl2m(read(this));
      }
      zh() {
        return new (ValueTimeMark())(this.yh());
      }
      ai(timeMark) {
        Companion_getInstance();
        var tmp = read(this);
        var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
        // Inline function 'kotlin.time.Companion.milliseconds' call
        var this_0 = tmp - (typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE());
        return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
      }
      bi(one, another) {
        var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
        var ms1 = typeof tmp === 'number' ? tmp : THROW_CCE();
        var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
        var ms2 = typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE();
        var tmp_1;
        if (ms1 === ms2) {
          tmp_1 = Companion_getInstance().fi_1;
        } else {
          Companion_getInstance();
          // Inline function 'kotlin.time.Companion.milliseconds' call
          var this_0 = ms1 - ms2;
          tmp_1 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
        }
        return tmp_1;
      }
      toString() {
        return 'TimeSource(self.performance.now())';
      }
    }
    initMetadataForClass($, 'PerformanceTimeSource');
    PerformanceTimeSourceClass = $;
  }
  return PerformanceTimeSourceClass;
}
function read_0($this) {
  return Date.now();
}
var DateNowTimeSourceClass;
function DateNowTimeSource() {
  if (DateNowTimeSourceClass === VOID) {
    class $ {
      yh() {
        return _ValueTimeMark___init__impl__uyfl2m(read_0(this));
      }
      zh() {
        return new (ValueTimeMark())(this.yh());
      }
      ai(timeMark) {
        Companion_getInstance();
        var tmp = read_0(this);
        var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
        // Inline function 'kotlin.time.Companion.milliseconds' call
        var this_0 = tmp - (typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE());
        return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
      }
      bi(one, another) {
        var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
        var ms1 = typeof tmp === 'number' ? tmp : THROW_CCE();
        var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
        var ms2 = typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE();
        var tmp_1;
        if (ms1 === ms2) {
          tmp_1 = Companion_getInstance().fi_1;
        } else {
          Companion_getInstance();
          // Inline function 'kotlin.time.Companion.milliseconds' call
          var this_0 = ms1 - ms2;
          tmp_1 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
        }
        return tmp_1;
      }
      toString() {
        return 'TimeSource(Date.now())';
      }
    }
    initMetadataForObject($, 'DateNowTimeSource');
    DateNowTimeSourceClass = $;
  }
  return DateNowTimeSourceClass;
}
var DateNowTimeSource_instance;
function DateNowTimeSource_getInstance() {
  return DateNowTimeSource_instance;
}
//region block: init
DateNowTimeSource_instance = new (DateNowTimeSource())();
//endregion
//region block: exports
export {
  MonotonicTimeSource_getInstance as MonotonicTimeSource_getInstance2excowedfjdg5,
};
//endregion

//# sourceMappingURL=MonoTimeSource.mjs.map
